import { TELIAPAY_METHOD } from '~/models/checkout/PaymentMethods.model';
import type {
  TPWebCheckoutResultEvent,
  WebCheckoutEventReturnedInCallbacks,
} from '~/models/checkout/TeliaPayWebCheckoutEvent.model';
import type { TeliaPayRequestObject } from '~/models/checkout/TeliaPayCheckout.model';

export const TeliaPayEventsToListenTo = {
  AUTHENTICATION: 'authentication',
  CLICKED_CONTINUE_BUTTON: 'clickedContinueButton',
  CLICKED_PAY_BUTTON: 'clickedPayButton',
  CREDIT_CHECK_DENIED: 'creditCheckDenied',
  ERROR: 'ERROR',
  INITIATED: 'INITIATED',
  PART_PAYMENT_AMOUNT_PER_MONTHS: 'partPaymentAmountPerMonth',
  PART_PAYMENT_CHOSEN_TERM: 'partPaymentChosenTerm',
  PART_PAYMENT_SELECTED_MONTHS: 'partPaymentSelectedMonths',
  REDIRECT_AT_CREDIT_DENIED: 'REDIRECT_AT_CREDIT_DENIED',
};

export type TeliaPayStandaleResultData = {
  webCheckoutEvent: TPWebCheckoutResultEvent;
  orderGuid: string;
};

export const useTeliaPay = (
  element: HTMLElement,
  teliaPayToken: string,
  preSelectedMonth: number,
) => {
  const { statisticsConsented } = useCookieConsent();
  const CURRENCY = 'SEK';

  const { $api } = useNuxtApp();

  const tpHandler: Ref<any> = ref();
  const tpResultOnComplete: Ref<TPWebCheckoutResultEvent | null> = ref(null);
  const tpResultOnFail: Ref<TPWebCheckoutResultEvent | null> = ref(null);

  // TODO: Custom css file in store
  // TODO: Use preSelectedMonth = PlanMonthPrice from telia token response? in Step4 component
  const config: TeliaPayRequestObject = {
    cookieConsent: { allowStatisticalCookies: !!statisticsConsented.value },
    customCssUrl: '',
    element,
    preSelectedMonth,
    purchaseRequestToken: teliaPayToken,
  };

  const initTeliaPay = async () => {
    tpHandler.value = await (window as any).initWebcheckout(config);
  };

  const runTeliaPay = async () => {
    try {
      const teliaPayResult = await tpHandler.value.start();
      tpResultOnComplete.value = teliaPayResult;
    } catch (failResult: any) {
      tpResultOnFail.value = failResult;
    }
  };

  const run = async () => {
    await initTeliaPay();
    await runTeliaPay();
  };

  run();

  const logEvent = async (event: WebCheckoutEventReturnedInCallbacks) => {
    try {
      await $api.teliaPay.postTeliaPayEvent({
        ...event,
        value: event.value || '',
        currency: CURRENCY,
        paymentMethod: TELIAPAY_METHOD,
      });
    } catch (e) {
      console.log(e);
    }
  };

  const updateBackendSelectedDownPayment = async (
    event: WebCheckoutEventReturnedInCallbacks,
  ) => {
    const downPayment = +event.value;

    if (!event.value || isNaN(downPayment)) {
      return;
    }

    /*
 TODO ta bort dessa om det funkar
    try {
      await $api.CustomerModule.setDownPayment(downPayment);
    } catch (e) {
      console.log(e);
    }
    */
  };

  const postResult = async (result: TPWebCheckoutResultEvent) => {
    try {
      const response = await $api.teliaPay.postTeliaPayResult(result);
      return response;
    } catch (e) {
      return e;
    }
  };

  const postStandaloneResult = async (data: TeliaPayStandaleResultData) => {
    try {
      const response = await $api.teliaPay.postTeliaPayStandaloneResult(data);
      return response;
    } catch (e) {
      return e;
    }
  };

  return {
    tpHandler,
    logEvent,
    postResult,
    tpResultOnComplete,
    tpResultOnFail,
    updateBackendSelectedDownPayment,
    postStandaloneResult,
  };
};
